export const EditIcon = ({ strokeColor = "currentColor", className }: { strokeColor?: string; className?: string }) => {
	return (
		<svg
			className={className}
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.99935 13.3333H13.9993M9.99935 3.33329L11.9993 5.33329M10.9167 2.41461C11.1821 2.14922 11.542 2.00012 11.9173 2.00012C12.2927 2.00012 12.6526 2.14922 12.918 2.41461C13.1834 2.68001 13.3325 3.03996 13.3325 3.41528C13.3325 3.7906 13.1834 4.15055 12.918 4.41595L4.91133 12.4233C4.75273 12.5819 4.55668 12.6979 4.34133 12.7606L2.42667 13.3193C2.3693 13.336 2.30849 13.337 2.25061 13.3222C2.19272 13.3074 2.13988 13.2772 2.09763 13.235C2.05538 13.1927 2.02526 13.1399 2.01043 13.082C1.9956 13.0241 1.9966 12.9633 2.01333 12.9059L2.572 10.9913C2.63481 10.7762 2.75083 10.5804 2.90933 10.4219L10.9167 2.41461Z"
				stroke={strokeColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
